module.exports = __webpack_public_path__ + "static/media/jumpoff-what-we-do-bg-colored-shapes-multi.99e57d03.jpg";